<template>
  <v-container fluid class="ertesitesek custom-bg" :style="bgColor">
    <div class="page-content">
      <div class="flex-center-between">
        <v-btn
          icon
          large
          color="primary"
          class="back-btn"
          @click="$goBackTo({ name: 'Fooldal' })"
        >
          <i class="fas fa-chevron-left"></i>
        </v-btn>
        <k-hamburger-icon class="back-btn" v-if="isMobile"></k-hamburger-icon>
      </div>
      <h2>Értesítések</h2>
      <k-ertesites-lista></k-ertesites-lista>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { AppStoreTypes } from '../store/modules/app';
import { timeout } from '../utils/common';

export default {
  name: 'Ertesitesek',
  data() {
    return {
      isLoading: false,
      ertesitesek: [],
    };
  },
  async mounted() {
    this.isLoading = true;
    await timeout(1000);
    this.isLoading = false;
  },
  created() {},
  methods: {},
  computed: {
    ...mapGetters({
      user: AppStoreTypes.user.get,
    }),
    bgColor() {
      return AppFunctions.GetBgColorStyle(this.user);
    },
    aktualisProjekt() {
      return this.user?.Projekt;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {},
  components: {},
};
</script>
